<template>
    <v-row no-gutters>
        <v-container>
            <template>
                <v-dialog v-model="dialog" persistent max-width="400">
                    <v-progress-linear v-if="isLoading" indeterminate color="indigo darken-2"></v-progress-linear>
                    <v-card>
                        <v-card-title class="text-h5">
                            Konfirmasi
                        </v-card-title>
                        <v-card-text style="min-height: 50px;">Apakah anda yakin isian anda sudah benar? </v-card-text>
                        <v-card-actions class="justify-content-center">
                            <v-spacer></v-spacer>
                            <v-btn :disabled="isLoading" color="indigo darken-4" text @click="onCloseDialog(false)">
                                Batal
                            </v-btn>
                            <v-btn :disabled="isLoading" color="indigo darken-4 white--text" @click="onCloseDialog(true)">
                                Simpan
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-alert text color="grey darken-1" class="p-4 rounded-lg " elevation="0">
                    <v-row style="line-height: 2rem;padding-left:20px;color: #000;">
                        <v-col cols="12" md="6" sm="6">
                            <tr>
                                <td><strong>Nama</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user ? user.name : '-' }}</td>
                            </tr>
                            <tr>
                                <td><strong>NIM</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user ? user.no_induk : '' }}</td>
                            </tr>
                            <tr>
                                <td><strong>Email</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user ? user.email : '' }}</td>
                            </tr>
                        </v-col>
                        <v-col cols="12" md="6" sm="6" v-if="isFTI">
                            <tr>
                                <td><strong>No. Hp</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user ? user.no_hp : '' }}</td>
                            </tr>
                            <tr>
                                <td><strong>IPK</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td>{{ user ? user.ipk : '' }}</td>
                            </tr>
                            <tr>
                                <td><strong>Nilai</strong></td>
                                <td>&ensp;:&emsp;</td>
                                <td v-if="kp !== null">{{ kp.nilai_angka ? kp.nilai_angka + (kp.nilai_huruf ? '/'
                                    + kp.nilai_huruf :
                                    '') : '-' }}</td>
                            </tr>
                        </v-col>
                    </v-row>
                </v-alert>
                <v-row v-if="kp !== null">
                    <v-col cols="12" md="3" sm="12">
                        <v-card class="rounded-lg mb-4" outlined color="blue-grey darken-1">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="text-overline mb-4 white--text">
                                        Rencana KP
                                    </div>
                                    <v-list-item-title class="text-h6 mb-1 white--text">
                                        {{ kp.tanggal_rencana_mulai_kp }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-icon size="80" style="opacity:0.2">mdi-clock-in</v-icon>
                            </v-list-item>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <v-card class="rounded-lg mb-4" outlined color="teal darken-3">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="text-overline mb-4 white--text">
                                        Mulai KP
                                    </div>
                                    <v-list-item-title class="text-h6 mb-1 white--text">
                                        {{ kp.tanggal_realisasi_mulai_kp || '-' }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-icon size="80" style="opacity:0.2">mdi-clipboard-clock-outline</v-icon>
                            </v-list-item>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <v-card class="rounded-lg mb-4" outlined color="teal darken-3">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="text-overline mb-4 white--text">
                                        Lama KP
                                    </div>
                                    <v-list-item-title class="text-h6 mb-1 white--text">
                                        {{ lama_kp || '-' }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-icon size="80" style="opacity:0.2">mdi-clipboard-clock-outline</v-icon>
                            </v-list-item>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                        <v-card class="white--text rounded-lg mb-4" outlined color="green">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="text-overline mb-4 white--text">
                                        Selesai KP
                                    </div>
                                    <v-list-item-title class="text-h6 mb-1 white--text">
                                        {{ kp.tanggal_realisasi_selesai_kp || '-' }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-icon size="80" style="opacity:0.2">mdi-clipboard-check-outline</v-icon>
                            </v-list-item>
                        </v-card>
                    </v-col>
                </v-row>
                <v-tabs v-model="tabs" background-color="indigo lighten-5" grow elevation="1">
                    <v-tab href="#tab-1" active-class="indigo darken-3 white--text rounded-xl rounded-b-0 ">
                        Data
                    </v-tab>
                    <v-tab href="#tab-2" active-class="indigo darken-3 white--text rounded-xl rounded-b-0">
                        Riwayat
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs" v-if="kp !== null">
                    <v-tab-item value="tab-1">
                        <v-stepper v-model="step" vertical>
                            <v-stepper-step complete step="1" @click="step = 1" style="cursor: pointer;">
                                Pendaftaran
                            </v-stepper-step>

                            <v-stepper-content step="1">
                                <v-alert v-if="kp !== null && kp.level_aproval_sekarang == 3" border="left"
                                    color="red lighten-2" dark>
                                    <div>
                                        <h6 class="text-body-1"><strong>Perlu perbaikan</strong></h6>
                                        <p class="text-caption mb-1">Catatan: {{ kp.catatan }}</p>
                                    </div>
                                </v-alert>
                                <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                                    <v-container class="p-4">
                                        <h6 class="text-body-1 pb-5 indigo--text text--darken-4">Isian<v-icon
                                                class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Tanggal daftar di sistem</label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ kp.created_at }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Rencana mulai kp</label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ kp.tanggal_rencana_mulai_kp }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="4" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Rencana selesai kp</label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ kp.tanggal_rencana_selesai_kp }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Kuliah prasyarat</label>
                                                <v-alert dense class="rounded-lg" elevation="1"
                                                    v-if="kp.matakuliah_prasyarat.length > 0">
                                                    <div class="d-flex">
                                                        <div class="text-body-2 mr-1"
                                                            v-for="(vals, indexItem) in kp.matakuliah_prasyarat">
                                                            <v-chip>{{ (indexItem + 1) + '. ' + vals.matakuliah
                                                            }}</v-chip>
                                                        </div>
                                                    </div>
                                                </v-alert>
                                                <v-alert dense class="rounded-lg" elevation="1" v-else>
                                                    -
                                                </v-alert>
                                            </v-col>
                                            <v-col>
                                                <v-col cols="12" sm="12" class="p-0" v-if="$isFTSP">
                                                    <label class="mb-2 font-weight-bold">Kategori perusahaan</label>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2">
                                                                {{ kp.kategori_perusahaan.name }}
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </v-col>
                                                <v-col cols="12" sm="12" class="p-0" v-if="$isFTSP">
                                                    <label class="mb-2 font-weight-bold">Bidang topik</label>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2">
                                                                {{ kp.bidang_topik.name }}
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </v-col>
                                                <v-col cols="12" sm="12" class="p-0">
                                                    <label class="mb-2 font-weight-bold">Nama perusahaan tujuan</label>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2">
                                                                {{ kp.perusahaan_tujuan }}
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </v-col>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="6" class="pb-0 pt-0 mt-2">
                                                <label class="mb-2 font-weight-bold">Alamat perusahaan</label>
                                                <v-alert dense class="rounded-lg" elevation="1" min-height="120px">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ kp.alamat_perusahaan }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                        </v-row>
                                        <v-divider class="indigo--text mb-0"></v-divider>
                                        <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                                class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="6" class="pb-0 pt-0"
                                                v-for="(doc, index) in kp.dokumen" v-bind:key="doc.id">
                                                <label class="mb-2 font-weight-bold">{{ (index + 1) +
                                                    '.' + doc.nama_jenis_dokumen }}</label>
                                                <div v-if="doc.dokumen.length > 0">
                                                    <v-alert dense class="rounded-lg" elevation="1"
                                                        v-for="(file, indexFile) in doc.dokumen" v-bind:key="file.id">
                                                        <div class="d-flex justify-space-between">
                                                            <h6 class="text-body-2 mb-0">
                                                                {{ file.nama_dokumen }}
                                                                <p class="text-caption text-muted mb-0"> {{
                                                                    $dates.dateNoDayWithTime(file.created_at) }}</p>
                                                            </h6>
                                                            <a style="text-decoration:none;" :href="file.url"
                                                                target="_blank">
                                                                <v-icon>mdi-eye</v-icon>
                                                            </a>
                                                        </div>
                                                    </v-alert>
                                                </div>
                                                <div v-else>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2 text-muted font-italic">
                                                                Tidak memiliki dokumen
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </div>

                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                                <v-btn v-if="kp !== null && kp.level_aproval_sekarang >= 4" color="primary"
                                    @click="step = 2">
                                    Selanjutnya
                                </v-btn>
                            </v-stepper-content>

                            <v-stepper-step step="2" :complete="kp.level_aproval_sekarang > 4"
                                @click="kp.level_aproval_sekarang >= 4 ? step = 2 : null" style="cursor:pointer;">
                                Unggah Surat Balasan
                                <small>Realisasi mulai KP, Surat balasan</small>
                            </v-stepper-step>

                            <v-stepper-content step="2">
                                <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                                    <v-container class="p-4">
                                        <v-card class="p-3 mb-3 indigo lighten-5" v-if="kp.level_aproval_sekarang >= 1">
                                            Surat pengantar ke perusahaan sudah tersedia.
                                            <p class="text-caption">Unduh <strong>Surat pengantar</strong> ke perusahaan,
                                                dan
                                                tunggu surat balasan. <strong>Surat balasan diterima</strong>
                                                perusahaan diperlukan untuk melanjutkan kp.</p>
                                            <v-row>
                                                <a :href="urlCetakSuratPengantar()">
                                                    <v-col cols="12" md="6" sm="12" class="pb-0">
                                                        <v-alert dense right outlined color="blue darken-4"
                                                            icon="mdi-file-download"
                                                            class="card-file-download rounded-lg d-flex align-self-end">
                                                            <p class="m-0">pengantar_perusahaan.pdf</p>
                                                        </v-alert>
                                                    </v-col>
                                                </a>
                                            </v-row>
                                        </v-card>
                                        <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Mulai KP<v-icon
                                                class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                                        <v-row class="pt-2">
                                            <v-col cols="12" sm="12" md="6" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Tanggal realisasi mulai KP</label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ kp.tanggal_realisasi_mulai_kp || '-' }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="6" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">{{
                                                    kp.surat_balasan.jenis_surat.jenis_surat || '-' }}</label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2">
                                                            {{ kp.surat_balasan.nama || '-' }}
                                                        </div>
                                                        <a style="text-decoration:none;" :href="kp.surat_balasan.url || '#'"
                                                            target="_blank">
                                                            <v-icon>mdi-eye</v-icon>
                                                        </a>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card>
                                <v-btn text color="indigo" outlined @click="step = 1">
                                    Sebelumnya
                                </v-btn>
                                <v-btn color="primary" v-if="kp !== null && kp.level_aproval_sekarang >= 7"
                                    @click="step = 3">
                                    Selanjutnya
                                </v-btn>
                            </v-stepper-content>

                            <v-stepper-step step="3" :complete="kp.level_aproval_sekarang > 7"
                                @click="kp.level_aproval_sekarang >= 7 ? step = 3 : null" style="cursor:pointer;">
                                Unggah Laporan KP
                                <small>Laporan KP, Logbook Kegiatan, Lembar penilaian</small>
                            </v-stepper-step>

                            <v-stepper-content step="3">
                                <v-card class="mb-12 rounded-xl grey lighten-4" elevation="0">
                                    <v-container class="p-4">
                                        <v-card text class="p-3 mb-5 rounded-lg indigo lighten-5">
                                            Unduh dokumen
                                            <p class="text-caption">Dokumen tersebut akan digunakan untuk syarat selesai KP
                                            </p>
                                            <v-row>
                                                <v-col cols="12" md="6" sm="12" class="pb-0">
                                                    <a :href="$unduh.lembarPenilaianPembimbing()">
                                                        <v-alert dense right outlined color="blue darken-4"
                                                            icon="mdi-file-download"
                                                            class="card-file-download rounded-lg d-flex align-self-end">
                                                            <p class="m-0">penilaian_pembimbing.docx</p>
                                                        </v-alert>
                                                    </a>
                                                </v-col>
                                                <v-col cols="12" md="6" sm="12" class="pb-0">
                                                    <a :href="$unduh.lembarKonsultasi()">
                                                        <v-alert dense right outlined color="blue darken-4"
                                                            icon="mdi-file-download"
                                                            class="card-file-download rounded-lg d-flex align-self-end">
                                                            <p class="m-0">lembar_konsultasi.docx</p>
                                                        </v-alert>
                                                    </a>
                                                </v-col>
                                                <v-col cols="12" md="6" sm="12" class="pb-0">
                                                    <a :href="$unduh.lembarKegiatan()">
                                                        <v-alert dense right outlined color="blue darken-4"
                                                            icon="mdi-file-download"
                                                            class="card-file-download rounded-lg d-flex align-self-end">
                                                            <p class="m-0">lembar_kegiatan.docx</p>
                                                        </v-alert>
                                                    </a>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                        <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Dosen
                                            pembimbing<v-icon class="indigo--text text--darken-4">mdi-chevron-right</v-icon>
                                        </h6>
                                        <v-row class="pt-2">
                                            <v-col cols="12" sm="12" md="6" class="pb-0 pt-0">
                                                <label class="mb-2 font-weight-bold">Dosen pembimbing </label>
                                                <v-alert dense class="rounded-lg" elevation="1">
                                                    <div class="d-flex justify-space-between">
                                                        <div class="text-body-2" v-if="kp !== null">
                                                            {{ kp.dosen_pembimbing.length > 0 ? kp.dosen_pembimbing[0].name
                                                                : '-' }}
                                                        </div>
                                                    </div>
                                                </v-alert>
                                            </v-col>
                                        </v-row>
                                        <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4">Berkas<v-icon
                                                class="indigo--text text--darken-4">mdi-chevron-right</v-icon>
                                        </h6>
                                        <v-row v-if="kp.laporan">
                                            <v-col cols="12" sm="12" md="6" class="pb-0 pt-0"
                                                v-for="(doc, index) in $dokumen.laporan(kp.laporan)" v-bind:key="doc.id">
                                                <label class="mb-2 font-weight-bold">
                                                    {{ (index + 1) + '. ' + doc.nama_jenis_dokumen }}</label>
                                                <div v-if="doc.dokumen.length > 0">
                                                    <v-alert dense class="rounded-lg" elevation="1"
                                                        v-for="(file, indexFile) in doc.dokumen" v-bind:key="file.id">
                                                        <div class="d-flex justify-space-between">
                                                            <h6 class="text-body-2 mb-0">
                                                                {{ file.nama_dokumen }}
                                                                <p class="text-caption text-muted mb-0"> {{
                                                                    $dates.dateNoDayWithTime(file.created_at) }}</p>
                                                            </h6>
                                                            <a style="text-decoration:none;" :href="file.url"
                                                                target="_blank">
                                                                <v-icon>mdi-eye</v-icon>
                                                            </a>
                                                        </div>
                                                    </v-alert>
                                                </div>
                                                <div v-else>
                                                    <v-alert dense class="rounded-lg" elevation="1">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="text-body-2 text-muted font-italic">
                                                                Belum mengunggah dokumen
                                                            </div>
                                                        </div>
                                                    </v-alert>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" sm="12" md="6">
                                                Belum ada dokumen
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-divider class="indigo--text mb-0"></v-divider>
                                            <v-card
                                                v-if="role.includes(3) && !kp.nilai_angka && kp.level_aproval_sekarang == 10 && !rubricExists"
                                                class="mb-4 mt-4 rounded-xl grey lighten-5" elevation="1">
                                                <v-container class="p-4 pb-0">
                                                    <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4 ">Beri
                                                        nilai akhir
                                                        <v-icon
                                                            class="indigo--text text--darken-4">mdi-chevron-right</v-icon>
                                                    </h6>
                                                    <v-form ref="formNilai" v-model="formModel" lazy-validation>
                                                        <v-row>
                                                            <v-col cols="12" md="6">
                                                                <v-text-field filled background-color="white"
                                                                    label="Nilai angka" v-model="formNilai.nilai_angka"
                                                                    placeholder="1-100" type="number"
                                                                    :rules="$rules.required_number_value"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <v-text-field filled background-color="white"
                                                                    @keyup="uppercase" label="Nilai huruf" type="text"
                                                                    v-model="formNilai.nilai_huruf" placeholder="A-D"
                                                                    :rules="$rules.required_nilai"></v-text-field>
                                                            </v-col>

                                                            <h4>Nilai Akhir: <span
                                                                    class="font-weight-bold indigo--text text--darken-4">{{
                                                                        (formNilai.nilai_angka || '') + (formNilai.nilai_huruf ?
                                                                            '/' + formNilai.nilai_huruf : '') }}</span> </h4>
                                                        </v-row>
                                                    </v-form>
                                                    <div class="d-flex justify-content-center py-5">
                                                        <v-btn color="primary" :disabled="isLoading" @click="onClickRate()">
                                                            Beri Nilai
                                                        </v-btn>
                                                    </div>
                                                </v-container>
                                            </v-card>
                                            <v-card
                                                v-if="role.includes(3) && !kp.nilai_angka && kp.level_aproval_sekarang == 10 && rubricExists"
                                                class="mb-4 mt-4 rounded-xl grey lighten-5" elevation="1">
                                                <v-container class="p-4 pb-0">
                                                    <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4 ">Rubrik
                                                        penilaian
                                                        <v-icon
                                                            class="indigo--text text--darken-4">mdi-chevron-right</v-icon>
                                                    </h6>
                                                    <v-form ref="formNilai" v-model="formModel" lazy-validation>
                                                        <v-row>
                                                            <v-simple-table>
                                                                <template>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                No.
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Komponen
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Bobot
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Nilai
                                                                            </th>
                                                                            <th class="text-left" v-if="$isFTSP">
                                                                                Nilai huruf
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item, index) in rubric.komponen">
                                                                            <td color="indigo--text text--darken-4">{{
                                                                                index + 1 }}</td>
                                                                            <td>
                                                                                <v-textarea flat rows="1" :auto-grow="true"
                                                                                    :full-width="true"
                                                                                    v-model="rubric.komponen[index].nama_komponen"
                                                                                    :hide-details="true" :readonly="true"
                                                                                    :rules="$rules.required" solo required
                                                                                    placeholder="Nama komponen"></v-textarea>
                                                                            </td>
                                                                            <td><v-text-field flat :hide-details="true"
                                                                                    :auto-grow="true" :full-width="true"
                                                                                    v-model="rubric.komponen[index].bobot"
                                                                                    :readonly="true"
                                                                                    :rules="$rules.required" solo required
                                                                                    placeholder="Bobot"></v-text-field>
                                                                            </td>
                                                                            <td><v-text-field flat :hide-details="true"
                                                                                    :auto-grow="true" :full-width="true"
                                                                                    v-model="rubric.komponen[index].nilai"
                                                                                    type="number"
                                                                                    @keydown="onKeydownNilai"
                                                                                    @input="onInputNilai(index, $event)"
                                                                                    :rules="$rules.nilai_required" solo
                                                                                    required
                                                                                    placeholder="Nilai"></v-text-field>
                                                                            </td>
                                                                            <td v-if="$isFTSP"><v-text-field flat
                                                                                    :hide-details="true"
                                                                                    :auto-grow="true" :full-width="true"
                                                                                    :value="$nilai.huruf(item.nilai)"
                                                                                    :readonly="true" :disabled="true"
                                                                                    solo
                                                                                    placeholder="Nilai huruf"></v-text-field>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </template>
                                                            </v-simple-table>
                                                        </v-row>
                                                    </v-form>
                                                    <h4 v-if="$isFTSP" class="mt-5">Nilai Akhir: <span
                                                            class="font-weight-bold indigo--text text--darken-4">{{
                                                                nilaiAkhirRubrik }}</span></h4>
                                                    <div class="d-flex justify-content-center py-5 mt-5">
                                                        <v-btn color="primary" :disabled="isLoading" @click="onClickRate()">
                                                            Beri Nilai
                                                        </v-btn>
                                                    </div>
                                                </v-container>
                                            </v-card>
                                        </v-row>
                                    </v-container>
                                </v-card>

                                <v-btn text color="indigo" outlined @click="step = 2">
                                    Sebelumnya
                                </v-btn>
                                <v-btn v-if="kp.level_aproval_sekarang >= 10" color="primary" @click="step = 4">
                                    Selanjutnya
                                </v-btn>
                            </v-stepper-content>

                            <v-stepper-step step="4">
                                Selesai
                            </v-stepper-step>

                            <v-stepper-content step="4">
                                <v-card class="mb-12 rounded-xl indigo lighten-5" elevation="0">
                                    <v-container class="p-4">
                                        <h5 class="text-body-1">Kerja praktik sudah selesai.</h5>
                                        <div class="pb-5" v-if="kp.detail_nilai.length > 0">
                                            <h6 class="text-body-1 pb-5 pt-5 indigo--text text--darken-4 ">Rubrik
                                                penilaian
                                                <v-icon class="indigo--text text--darken-4">mdi-chevron-right</v-icon>
                                            </h6>
                                            <v-row>
                                                <v-simple-table>
                                                    <template>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    No.
                                                                </th>
                                                                <th class="text-left">
                                                                    Komponen
                                                                </th>
                                                                <th class="text-left">
                                                                    Bobot
                                                                </th>
                                                                <th class="text-left">
                                                                    Nilai
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in kp.detail_nilai">
                                                                <td color="indigo--text text--darken-4">{{
                                                                    index + 1 }}</td>
                                                                <td>
                                                                    {{ item.nama_komponen }}
                                                                </td>
                                                                <td>
                                                                    {{ item.bobot }}
                                                                </td>
                                                                <td>
                                                                    {{ item.nilai }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-row>
                                        </div>
                                        <h4>Nilai: <span class="font-weight-bold indigo--text text--darken-4 text-h4">{{
                                            $nilai.tampil(kp.nilai_angka, kp.nilai_huruf) }}</span></h4>
                                    </v-container>
                                </v-card>
                                <v-btn text color="indigo" outlined @click="step = 3">
                                    Sebelumnya
                                </v-btn>

                            </v-stepper-content>
                        </v-stepper>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                        <template>
                            <v-stepper v-model="stepers" vertical class="rounded-lg">
                                <h4
                                    class="text-body-1 font-weight-bold text-decoration-underline indigo--text text--darken-4 p-3">
                                    Riwayat pendaftaran</h4>
                                <div v-for="(item, index) in riwayat">
                                    <v-stepper-content step="">

                                    </v-stepper-content>

                                    <v-stepper-step step="">
                                        <v-row justify="space-between">
                                            <v-col cols="7">
                                                {{ item.status }} <br>
                                                <small v-if="item.catatan_aproval">Catatan: {{ item.catatan_aproval
                                                }}</small>
                                                <small>Oleh: {{ item.user_aproval.nama }}</small>
                                            </v-col>
                                            <v-col class="text-right" cols="5">
                                                <small>{{ item.time }}<br>{{ item.date }}</small>
                                            </v-col>
                                        </v-row>
                                    </v-stepper-step>
                                </div>
                            </v-stepper>
                        </template>
                    </v-tab-item>
                </v-tabs-items>
                <div class="d-flex justify-content-center">
                    <v-btn outlined color="primary" @click="buttonBackClick()">
                        Kembali
                    </v-btn>
                </div>
            </template>
        </v-container>
    </v-row>
</template>
<script>
import { serialize } from "object-to-formdata";
export default {
    data: () => ({
        formModel: true,
        isLoading: false,
        dialog: false,
        stepers: 1,
        riwayat: [],
        tabs: null,
        step: 1,
        lama_kp: undefined,
        kpid: undefined,
        user: undefined,
        kp: null,
        role: null,
        formNilai: {
            nilai_angka: null,
            nilai_huruf: null,

        },
        komponen: [],
        rubricExists: undefined,
        rubric: undefined
    }),
    created() {
        let auths = JSON.parse(localStorage.getItem("user"));
        if (auths)
            this.role = auths.roles.map(ro => {
                return ro.id;
            }),
                this.kpid = this.$route.query.uuid.split('$')[0];
        this.getData();
    },
    mounted() {

    },
    computed: {
        nilaiAkhirRubrik() {
            if (!this.rubric) return '-';
            return this.$nilai.format(this.$nilai.akhirRubrik(this.rubric.komponen));
        }
    },
    methods: {
        onKeydownNilai(event) {
            if (['.', ',', 'e', 'E', '+', '-'].includes(event.key)) event.preventDefault();
        },
        onInputNilai(index, value) {
            const angka = String(value === null || value === undefined ? '' : value)
                .replace(/[^\d.]/g, '')
                .split('.')[0];
            this.rubric.komponen[index].nilai = angka;
        },
        getData() {
            this.axios.get("/api/mahasiswa/kp/" + this.kpid).then((res) => {
                this.user = res.data.data;
                this.kp = this.user.kp;
                let nows = new Date();
                if (this.kp.tanggal_realisasi_selesai_kp) {
                    nows = this.kp.tanggal_realisasi_selesai_kp;
                }
                if (this.kp.tanggal_realisasi_mulai_kp) {
                    this.lama_kp = this.$dates.dateDiff(this.kp.tanggal_realisasi_mulai_kp, nows);
                }
                this.kp.created_at = this.$dates.dateNoDayNoTime(this.kp.created_at);
                this.kp.tanggal_rencana_mulai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_rencana_mulai_kp);
                this.kp.tanggal_rencana_selesai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_rencana_selesai_kp);
                this.kp.tanggal_realisasi_mulai_kp !== null ? this.kp.tanggal_realisasi_mulai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_realisasi_mulai_kp) : '-';
                if (this.kp.tanggal_realisasi_selesai_kp) {
                    this.kp.tanggal_realisasi_selesai_kp = this.$dates.dateNoDayNoTime(this.kp.tanggal_realisasi_selesai_kp);
                }
                this.getStep(this.kp.level_aproval_sekarang);
                if (this.role.includes(3) && !this.kp.nilai_angka && this.kp.laporan[0].dokumen.length !== 0) {
                    this.getRubric();
                }
                this.getRiwayat();
            })
                .catch((err) => console.log(this.kp = null))
                .finally(() => console.log(this.kp, 'KPs'));
        },
        getStep(level) {
            switch (level) {
                case '1':
                    this.step = 1;
                    break;
                case '4':
                    this.step = 2;
                    break;
                case '7':
                    this.step = 3;
                    break;
                case '10':
                    this.step = 3;
                    break;
                case '11':
                    this.step = 4;
                    break;

                default:
                    break;
            }
        },
        getRubric() {
            this.axios.get("/api/kp/" + this.kp.id + '/form-penilaian').then((res) => {
                this.rubric = res.data.data;
                this.rubricExists = this.rubric.rubrik;
                if (this.rubricExists) {
                    this.getListRubric();
                }
            })
                .catch((err) => this.riwayat = null)
                .finally(() => console.log('riwayat->loaded'));
        },
        getRiwayat() {
            this.axios.get("/api/kp/" + this.kp.id + '/riwayat').then((res) => {
                this.riwayat = res.data.data.sort();
                if (this.riwayat) {
                    this.riwayat = this.riwayat.map(val => {
                        val.time = new Date(val.created_at).getHours() + ':' + new Date(val.created_at).getMinutes();
                        val.date = new Date(val.created_at).toLocaleDateString('id-ID', { month: 'short', year: 'numeric', day: 'numeric' });
                        return val;
                    }).sort(function (a, b) {
                        var keyA = new Date(a.created_at),
                            keyB = new Date(b.created_at);
                        // Compare the 2 dates
                        if (keyA < keyB) return 1;
                        if (keyA > keyB) return -1;
                        return 0;
                    });
                }
            })
                .catch((err) => this.riwayat = null)
                .finally(() => console.log('riwayat->loaded'));
        },
        uppercase() {
            this.formNilai.nilai_huruf = this.formNilai.nilai_huruf.toUpperCase();
        },
        onClickRate() {
            this.dialog = true;
        },
        onCloseDialog(event) {
            if (event) {
                this.submitNilai();
            } else {
                this.dialog = false;
            }
        },
        submitNilai() {
            let url = "/api/kp/" + this.kpid + "/nilai";
            const valid = this.$refs.formNilai.validate();
            if (valid) {
                this.isLoading = true;
                const options = {
                    indices: false,
                    nullsAsUndefineds: false,
                    booleansAsIntegers: false,
                    allowEmptyArrays: false,
                    noFilesWithArrayNotation: false,
                    dotsForObjectNotation: false,
                };
                // this.formNilai["_method"] = "put";
                let formData = new FormData();
                formData = serialize(this.formNilai, options);
                formData.append('rubrik', this.rubricExists ? 1 : 0);
                if (this.rubricExists) {
                    formData.append('rubrik_id', this.rubric.id);
                    this.rubric.komponen.forEach((el, i) => {
                        formData.append('komponen[' + i + '][nama]', el.nama_komponen);
                        formData.append('komponen[' + i + '][komponen_ke]', el.komponen_ke);
                        formData.append('komponen[' + i + '][bobot]', el.bobot);
                        formData.append('komponen[' + i + '][nilai]', el.nilai);
                    });
                }
                this.axios
                    .post(url, formData)
                    .then((res) => {
                        this.$emit("toast", "success", "Berhasil menilai KP");
                        if (this.role.includes(3)) {
                            this.$router.push({ name: "home-lecturer" });
                        } else {
                            this.$router.push({ name: "welcome" });
                        }
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.$emit("toast", "warning", "Isian nilai tidak valid");
                this.dialog = false;
            }
        },
        urlCetakSuratPengantar() {
            return this.$baseurl + '/api/cetak/' + this.kp.id + '/surat-pengantar';
        },
        buttonBackClick() {
            if (this.role.includes(3)) {
                this.$router.push({ name: "home-lecturer" });
            } else if (this.role.includes(2)) {
                this.$router.push({ name: "recapitulation-internship-officer" });
            } else {
                this.$router.push({ name: "welcome" });
            }
        },

    }
}
</script>
<style>
.card-file-download {
    font-size: calc(0.5em + 1vmin);
    cursor: pointer;

}

.card-file-download:hover {
    transform: scale(1.02);
    opacity: 0.5;
}

@media only screen and (max-width: 600px) {
    .card-file-download {
        font-size: calc(0.3em + 1vmin);
    }
}
</style>